// extracted by mini-css-extract-plugin
export default {"root":"root__ot2kP0JLiOdd","labels":"labels__B1nnopJ37FET"};